
import React from "react";
import css from './SectionGrid421.module.css';

const SectionGrid41 = props => {
    const { header, content, footer, backgroundColor } = props;

    return (
        <div className={css.root} style={backgroundColor ? { "backgroundColor": backgroundColor } : null}>

            <div className={css.content}>
                {header}
                <div className={css.gridContainer}>
                    {content}
                </div>
                {footer}
            </div>
        </div>
    );
};

export default SectionGrid41;
